export { useTealium } from "./hooks";
export { TealiumProvider } from "./context";
export { default as Tealium } from "./withGlobalData";
